<script setup lang="ts">
/**
 * The interface icons, drawn in the same line style as the weather glyphs. Strokes keep
 * their width in CSS pixels whatever size the icon is rendered at.
 */
const PATHS = {
  refresh: "M19.4 15a8 8 0 1 1-1.9-8.3L20 9M20 4v5h-5",
  sun: "M12 8a4 4 0 1 0 0 8a4 4 0 0 0 0-8zM12 2.5V5M12 19v2.5M2.5 12H5M19 12h2.5M5.3 5.3l1.75 1.75M16.95 16.95l1.75 1.75M5.3 18.7l1.75-1.75M16.95 7.05l1.75-1.75",
  moon: "M20 14.2A8.4 8.4 0 1 1 9.8 4a6.6 6.6 0 0 0 10.2 10.2z",
  "chevron-right": "M9 5l7 7-7 7",
  "chevron-down": "M5 9l7 7 7-7",
  "arrow-right": "M4 12h16M14 6l6 6-6 6",
  "arrow-left": "M20 12H4M10 6l-6 6 6 6",
  "arrow-up-right": "M7 17L17 7M8.5 7H17v8.5",
  close: "M6 6l12 12M18 6L6 18",
  warning: "M12 4.2l8.6 15H3.4zM12 10v4.4M12 17.1v.01"
} as const;

withDefaults(defineProps<{ name: keyof typeof PATHS; size?: number }>(), { size: 16 });
</script>

<template>
  <svg class="icon" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true">
    <path :d="PATHS[name]" />
  </svg>
</template>

<style scoped>
.icon {
  display: block;
  flex: 0 0 auto;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.5px;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.icon path { vector-effect: non-scaling-stroke; }
</style>
